import { Fragment, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Box, Divider, Grid, Typography } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";

import { getTestAnswer, ITestAnswerClient } from "../../api/tests-answers";

export const PsychologyTest = () => {
  const [loading, setLoading] = useState(false);
  const [testAnswer, setTestAnswer] = useState<ITestAnswerClient | null>(null);

  const { patient } = useParams();

  useEffect(() => {
    const fetchTestAnswer = async () => {
      try {
        setLoading(true);
        const fetchedTestAnswer = await getTestAnswer(patient);
        setTestAnswer(fetchedTestAnswer);
      } catch (error) {
        console.error("Error fetching the test answer:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchTestAnswer();
  }, [patient]);

  return (
    <Grid container mt={5}>
      {loading ? (
        <Grid
          container
          sx={{
            height: "500px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <CircularProgress size={100} />
        </Grid>
      ) : (
        <>
          {testAnswer && testAnswer.saveTestAnswer.length > 0 ? (
            <>
              <Grid item xs={12} mb={5}>
                <Typography variant="h5" component="h5" fontWeight={600}>
                  Auswertung des psychologischen Fragebogens
                </Typography>
              </Grid>
              <Box>
                {testAnswer?.saveTestAnswer.map((answer, index) => (
                  <Grid container item xs={12} mb={4} key={index}>
                    {answer.evaluation.map((item, subIndex) => (
                      <Fragment key={subIndex}>
                        <Grid item xs={12}>
                          <Typography
                            variant="subtitle2"
                            fontWeight={600}
                            mt={2}
                          >
                            {item.title}
                          </Typography>
                        </Grid>
                        <Grid item xs={12}>
                          <Typography variant="subtitle2">
                            {item.value}
                          </Typography>
                        </Grid>
                      </Fragment>
                    ))}
                    <Grid item xs={12} sm={4} my={3}>
                      <Divider
                        variant="middle"
                        sx={{
                          borderBottomWidth: 3,
                          backgroundColor: "black",
                          mx: "0",
                        }}
                      />
                    </Grid>
                    {answer.summary.map((item, subIndex) => (
                      <Fragment key={subIndex}>
                        <Grid item xs={12}>
                          <Typography
                            variant="subtitle2"
                            fontWeight={600}
                            mt={2}
                          >
                            {item.title}
                          </Typography>
                        </Grid>
                        <Grid item xs={12}>
                          <Typography variant="subtitle2">
                            {item.value}
                          </Typography>
                        </Grid>
                      </Fragment>
                    ))}
                  </Grid>
                ))}
              </Box>
            </>
          ) : (
            <Grid>
              <Grid item xs={12} mb={15}>
                <Typography variant="h5" component="h5" fontWeight={600} mb={1}>
                  Auswertung des psychologischen Fragebogens
                </Typography>
                <Typography color="red">
                  Keine relevanten Informationen verfügbar
                </Typography>
              </Grid>
            </Grid>
          )}
        </>
      )}
    </Grid>
  );
};
